<div class="p-3 wrapper">
    <div class="inner">
        <div class="d-flex align-items-center justify-content-end top-panel">
            <button type="button" class="btn-close" aria-label="Close" (click)="closePopup()"></button>
        </div>
        <img class="d-none d-md-block" src="assets/images/popups/scolarship.png" width="100%" height="100%" alt="">
        <img class="d-block d-md-none" src="assets/images/popups/scolarship-mobile.png" width="100%" height="100%" alt="">
        <div class="d-flex align-items-center justify-content-center">
            <a href="https://www.youtube.com/@DPEducationMathsSinhala/streams" target="_blank" class="btn btn-visit" i18n="home schol: visit" >පිවිසෙන්න</a>
        </div>
    </div>
</div>